"use client";

import { List, Text, VStack } from "@chakra-ui/react";
import { PROFILE_SHAPING_LABELS } from "@/features/profile-shaping";

type SelectionSummaryProps = {
  freeListThoughtCount: number;
  situationCount: number;
  thoughtCount: number;
  hasSelectedSuggestions: boolean;
  printLanguage: string;
  profileFocusName?: string | null;
};

export default function SelectionSummary({
  freeListThoughtCount,
  situationCount,
  thoughtCount,
  hasSelectedSuggestions,
  printLanguage,
  profileFocusName,
}: SelectionSummaryProps) {
  return (
    <VStack align="stretch" gap="2">
      <Text fontWeight="medium">Current selection</Text>
      <List.Root ml="4">
        <List.Item>{situationCount} selected situations</List.Item>
        <List.Item>{thoughtCount} selected thoughts</List.Item>
        {freeListThoughtCount > 0 ? (
          <List.Item>{freeListThoughtCount} thoughts in free-list order</List.Item>
        ) : null}
        <List.Item>
          {profileFocusName
            ? `${PROFILE_SHAPING_LABELS.profileFocus}: ${profileFocusName}`
            : `No ${PROFILE_SHAPING_LABELS.profileFocus.toLowerCase()} selected`}
        </List.Item>
        <List.Item>Profile export language: {printLanguage}</List.Item>
      </List.Root>
      {hasSelectedSuggestions ? (
        <Text color="moveon.text.muted" fontSize="sm">
          Suggestions are temporary. Confirm them before saving a profile
          version.
        </Text>
      ) : null}
    </VStack>
  );
}
